export default __webpack_public_path__ + "static/benefit1Img-a2af996eb22db001254d1ec1dee81586.webp";